export const AUTH = {
    //设置加载状态
    SET_LOADING: 'setLoading',
    //设置请求状态
    SET_IS_REQUEST:'setIsRequest',
    //设置有权限的菜单列表
    SET_MENUS: 'setMenus',
    //设置有权限的路由列表
    SET_ROUTES: 'setRoutes',
    //设置有权限的按钮列表
    SET_BTNS: 'setBtns'
}

export const LIST = {
    //设置加载状态
    SET_LOADING: 'setLoading',
    //设置请求状态
    SET_IS_REQUEST:'setIsRequest',
    //公司
    SET_CORP_LIST: 'setcorp_list',
    //部门
    SET_DEPART_LIST:'setdepart_list',
    //小组
    SET_GROUP_LIST: 'setgroup_list',
}